import React, { useState } from 'react';
import './NadlanPage.css';
import './Pricing.css';

const NadlanPage = () => {
  const whatsappNumber = '+972545309673';
  const baseMessage = 'ברצוני לפרסם דירה למכירה, אנא חזרו אליי';
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\+/g, '')}?text=${encodeURIComponent(baseMessage)}`;

  const [openFaq, setOpenFaq] = useState(null);

  const getWhatsAppUrl = (plan) => {
    if (!plan) {
      return `https://wa.me/${whatsappNumber.replace(/\+/g, '')}?text=${encodeURIComponent(baseMessage)}`;
    }
    
    const priceText = plan.priceSymbol && plan.price !== 'מותאם'
      ? `${plan.priceSymbol}${plan.price} ${plan.period}`
      : `מחיר ${plan.period}`;
    
    const featuresText = plan.features
      .filter(f => f.included)
      .map(f => f.text)
      .join(', ');
    
    const message = `${baseMessage}\n\nאני מתעניין בחבילת ${plan.name}${plan.popular ? ' (מומלץ)' : ''}:\n${priceText}\n\nתכונות: ${featuresText}`;
    
    return `https://wa.me/${whatsappNumber.replace(/\+/g, '')}?text=${encodeURIComponent(message)}`;
  };

  const handlePageClick = (e) => {
    // Don't open WhatsApp if clicking on links, buttons, or interactive elements
    if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON' || e.target.closest('a') || e.target.closest('button') || e.target.closest('.faq-item')) {
      return;
    }
    window.open(whatsappUrl, '_blank');
  };

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // 3 חבילות חדשות מותאמות לדירות
  const plans = [
    {
      name: 'בסיס',
      price: '300',
      priceSymbol: '₪',
      period: 'לחודש',
      features: [
        { text: 'שדרוג תמונות', included: true },
        { text: 'מודעה משופרת', included: true },
        { text: 'וידאו', included: false }
      ]
    },
    {
      name: 'מומלץ',
      price: '500',
      priceSymbol: '₪',
      period: 'לחודש',
      popular: true,
      features: [
        { text: 'שדרוג תמונות', included: true },
        { text: 'וידאו שיווקי', included: true },
        { text: 'הפצה ממוקדת', included: true }
      ]
    },
    {
      name: 'פרימיום',
      price: 'מותאם',
      priceSymbol: '',
      period: 'מחיר',
      features: [
        { text: 'הכול', included: true },
        { text: 'עדיפות בהפצה', included: true },
        { text: 'ליווי אישי', included: true }
      ]
    }
  ];

  const renderCard = (plan, index) => (
    <a 
      key={index} 
      href={getWhatsAppUrl(plan)} 
      className={`pricing-card nadlan-pricing-card ${plan.popular ? 'popular' : ''}`}
      target="_blank" 
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="plan-name">
        {plan.popular && <span className="popular-badge">⭐</span>}
        {plan.name}
      </h3>
      <div className="plan-price">
        {plan.priceSymbol && <span className="price-symbol">{plan.priceSymbol}</span>}
        <span className="price">{plan.price}</span>
      </div>
      <div className="plan-period">{plan.period}</div>
      <ul className="plan-features nadlan-plan-features">
        {plan.features.map((feature, idx) => (
          <li key={idx} className="feature-item">
            {feature.included ? '✔' : '❌'} {feature.text}
          </li>
        ))}
      </ul>
      <span className="btn btn-pricing">
        🟢 בחר חבילה
      </span>
    </a>
  );

  const testimonials = [
    {
      text: 'הדירה נמכרה תוך 3 שבועות',
      author: 'דוד, תל אביב'
    },
    {
      text: 'יותר פניות ביום הראשון',
      author: 'שרה, ירושלים'
    },
    {
      text: 'חסך לי מתווך',
      author: 'מיכאל, חיפה'
    }
  ];

  const faqItems = [
    {
      question: 'צריך ידע טכני?',
      answer: 'לא. אנחנו עושים את כל העבודה עבורך. אתה רק מעלה תמונות ואנחנו דואגים לכל השאר.'
    },
    {
      question: 'זה מתאים גם לדירה ישנה?',
      answer: 'כן, בדיוק! AI יודע לשדרג תמונות ולהוסיף ריהוט וירטואלי כדי שהדירה תיראה במיטבה, גם אם היא ישנה.'
    },
    {
      question: 'כמה זמן זה לוקח?',
      answer: 'תהליך השדרוג וההפצה לוקח 24-48 שעות. לאחר מכן הפרסום מתחיל מיידית.'
    },
    {
      question: 'האם זה מחייב בלעדיות?',
      answer: 'לא. אתה יכול לפרסם גם במקומות אחרים. אנחנו רק עוזרים לך להבליט את הדירה טוב יותר.'
    },
    {
      question: 'האם זה מתאים לסוכניות תיווך?',
      answer: 'כן, בהחלט! סוכניות תיווך יכולות להשתמש בשירות שלנו כדי לשדרג את כל המודעות שלהן, להבליט דירות ולמשוך יותר קונים. השירות מתאים גם לפרסום מרובה דירות.'
    },
    {
      question: 'מה ההבדל בין מכירה פרטית למכירה דרך סוכנות?',
      answer: 'השירות שלנו מתאים לשני המקרים. משכירים פרטיים יכולים לפרסם את הדירה שלהם ישירות, וסוכניות תיווך יכולות להשתמש בשירות כדי לשדרג את כל המודעות שלהן ולמקסם את החשיפה של הדירות שלהן.'
    }
  ];

  return (
    <div className="nadlan-page" onClick={handlePageClick}>
      <header className="nadlan-banner">
        <div className="nadlan-logo">
          <img src="/logo.png" alt="GSRadio Partner" className="logo-image" />
        </div>
      </header>
      
      {/* 1. Hero Section */}
      <section className="nadlan-hero futuristic-hero">
        <div className="hero-room-overlay"></div>
        <div className="nadlan-container">
          <div className="nadlan-hero-content">
            <h1 className="nadlan-hero-title futuristic-title">
              🏠 מוכרים דירה יד שנייה?
              <br />
              כך תבלטו מעל כל המודעות – בעזרת AI
            </h1>
            <div className="hero-icons-row">
              <span className="holographic-icon">💡 תמונות משודרגות</span>
              <span className="icon-separator">|</span>
              <span className="holographic-icon">📹 וידאו שיווקי</span>
              <span className="icon-separator">|</span>
              <span className="holographic-icon">🚀 הפצה חכמה</span>
            </div>
            <p className="nadlan-hero-subtitle futuristic-subtitle">
              מתאים למשכירים פרטיים ולסוכניות תיווך כאחד
            </p>
            <a 
              href="#pricing" 
              className="nadlan-hero-cta futuristic-cta pulse-button"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                const pricingSection = document.getElementById('pricing');
                if (pricingSection) {
                  pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
            >
              🔵 בחרו חבילת פרסום
            </a>
          </div>
        </div>
      </section>

      {/* 2. הבעיה */}
      <section className="nadlan-problem-section futuristic-problem">
        <div className="problem-chart"></div>
        <div className="nadlan-container">
          <h2 className="nadlan-section-title futuristic-section-title">הבעיה</h2>
          <div className="nadlan-problem-items">
            <div className="nadlan-problem-item problem-glow">
              <span className="problem-icon pulse-x">❌</span>
              <p>הדירה לא בולטת בלוחות</p>
            </div>
            <div className="nadlan-problem-item problem-glow">
              <span className="problem-icon pulse-x">❌</span>
              <p>תמונות רגילות → פחות פניות</p>
            </div>
            <div className="nadlan-problem-item problem-glow">
              <span className="problem-icon pulse-x">❌</span>
              <p>הרבה סיורים, מעט רציניים</p>
            </div>
            <div className="nadlan-problem-item problem-glow">
              <span className="problem-icon pulse-x">❌</span>
              <p>ירידת מחיר מיותרת</p>
            </div>
          </div>
          <p className="nadlan-problem-message red-glow">
            ⚠️ רוב דירות יד 2 לא נמכרות בגלל איכות הדירה – אלא בגלל שיווק חלש.
          </p>
        </div>
      </section>

      {/* 3. הפתרון */}
      <section className="nadlan-solution-section futuristic-solution">
        <div className="neural-network-bg"></div>
        <div className="nadlan-container">
          <h2 className="nadlan-section-title futuristic-section-title">איך זה עובד?</h2>
          <div className="nadlan-solution-steps">
            <div className="nadlan-step step-glow">
              <div className="step-number">1</div>
              <div className="step-icon">☁️</div>
              <h3 className="step-title">מעלים תמונות</h3>
            </div>
            <div className="step-arrow digital-arrow">→</div>
            <div className="nadlan-step step-glow">
              <div className="step-number">2</div>
              <div className="step-icon">🧠</div>
              <h3 className="step-title">AI משדרג + יוצר וידאו</h3>
            </div>
            <div className="step-arrow digital-arrow">→</div>
            <div className="nadlan-step step-glow">
              <div className="step-number">3</div>
              <div className="step-icon">🌐</div>
              <h3 className="step-title">הפצה חכמה</h3>
            </div>
          </div>
        </div>
      </section>

      {/* 4. חבילות הפרסום */}
      <section id="pricing" className="pricing nadlan-pricing">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">חבילות פרסום</h2>
            <p className="section-subtitle">
              בחר את החבילה המתאימה לך. כל החבילות כוללות שדרוג תמונות מקצועי.
            </p>
          </div>
          <div className="pricing-grid">
            {plans.map((plan, index) => renderCard(plan, index))}
          </div>
        </div>
      </section>

      {/* 5. עדויות */}
      <section className="nadlan-testimonials futuristic-testimonials">
        <div className="city-map-bg"></div>
        <div className="nadlan-container">
          <h2 className="nadlan-section-title futuristic-section-title">מה אומרים הלקוחות</h2>
          <div className="nadlan-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="nadlan-testimonial-card testimonial-bubble">
                <div className="testimonial-icon">💬</div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <p className="testimonial-author">– {testimonial.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. שאלות נפוצות */}
      <section className="nadlan-faq futuristic-faq">
        <div className="nadlan-container">
          <h2 className="nadlan-section-title futuristic-section-title">שאלות נפוצות</h2>
          <div className="nadlan-faq-list">
            {faqItems.map((item, index) => (
              <div 
                key={index} 
                className={`faq-item faq-glow ${openFaq === index ? 'open' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFaq(index);
                }}
              >
                <div className="faq-question">
                  <h3>{item.question}</h3>
                  <span className="faq-toggle">{openFaq === index ? '−' : '+'}</span>
                </div>
                {openFaq === index && (
                  <div className="faq-answer digital-scan">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7. CTA סופי */}
      <section className="nadlan-final-cta futuristic-cta-section">
        <div className="city-skyline-bg"></div>
        <div className="data-network-overlay"></div>
        <div className="nadlan-container">
          <h2 className="nadlan-cta-title futuristic-cta-title">
            🚀 הדירה שלכם שווה יותר משיווק רגיל
            <br />
            תנו ל־AI לעבוד בשבילכם
          </h2>
          <a 
            href={whatsappUrl}
            className="nadlan-cta-button futuristic-cta-btn"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            🔵 להתחיל עכשיו
          </a>
          <div className="footer-logo">
            <img src="/logo.png" alt="GSRadio Partner" className="logo-image-footer" />
            <span className="logo-text">GSRadio - Partner</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NadlanPage;
